// extracted by css-extract-rspack-plugin
export default {"control":"mXT53","label":"a498B","item":"ce8Ua","content":"DxC05","chevron":"MqME4","panel":"Yn6q9"};